import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": ".1",
  d: "m12.543 12.17-.005.004c-.073.073-.155.178-.157.315-.026.136.03.27.137.352l5.736 5.026a.36.36 0 0 0 .272.108h6.711c.158 0 .297-.08.354-.218l1.918-3.529c.082-.112.078-.25.027-.377a.39.39 0 0 0-.296-.244l-4.156-.968-2.313-2.903a.42.42 0 0 0-.325-.161H16.13a.43.43 0 0 0-.24.08v-.001l-.003.002zm10.188 1.249.004.001 3.779.886-1.52 2.81h-6.307l-5.228-4.595 2.807-2.111h3.99l2.262 2.874.004.004c.052.053.13.104.21.131Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": ".1",
  d: "m27.093 13.752-.005.002a.455.455 0 0 0-.238.56l.925 2.537c.055.163.216.27.379.27h.003a.34.34 0 0 0 .162-.029.455.455 0 0 0 .238-.56l-.925-2.537a.42.42 0 0 0-.54-.243ZM20.862 30.424v.002H28.2c.138 0 .268-.082.387-.177l.008-.006.005-.009 2.893-5.099.001-.002a.45.45 0 0 0 .026-.372l-2.04-5.596a.42.42 0 0 0-.538-.243l-.005.002a.455.455 0 0 0-.238.56l1.96 5.409-2.677 4.697h-6.985l-6.12-1.488-5.543-6.817 3.757-8.39a.41.41 0 0 0-.188-.564l-.003-.001a.424.424 0 0 0-.539.213v.002L8.495 21.2a.41.41 0 0 0 .054.456l5.81 7.115.004.004c.052.052.13.104.209.13l.004.002z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": ".1",
  d: "M14.28 28.248v.001c-.077.233.023.472.235.557a.14.14 0 0 0 .07.027q.037.005.073.004h.002c.167 0 .299-.112.397-.26l.001.001.005-.012 1.66-4.577c.079-.237-.025-.48-.243-.562a.42.42 0 0 0-.539.243zM17.032 20.611v.002c-.078.232.022.472.234.557a.14.14 0 0 0 .07.027 1 1 0 0 0 .073.003h.002a.47.47 0 0 0 .4-.265l.003-.005 1.114-3.06c.08-.236-.025-.48-.243-.561a.42.42 0 0 0-.538.242v.001zM26.587 24.932v.003c.054.184.214.32.405.32h.07000000000000005v.002l.013-.003c.218-.055.35-.272.298-.51l-1.684-7.115c-.053-.238-.269-.377-.488-.322s-.35.272-.298.51z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }